import authSlice from "../redux/auth/slice";
import accountsSlice from "../redux/accounts/slice";
import staffsSlice from "../redux/staffs/slice";
import addressSlice from "../redux/address/slice";
import technicianSlice from "../redux/technician/slice";
import productsSlice from "../redux/product/slice";
import categoriesSlice from "../redux/categories/slice";
import companiesSlice from "../redux/companies/slice";
import serviceSlice from "../redux/service/slice";
import salesSlice from "../redux/sales/slice";
import settingSlice from "../redux/masterSetting/slice";
import dashboardSlice from "../redux/dashboard/slice";
import notificationSlice from "../redux/notification/slice";
import salesReportSlice from "../redux/reports/slice";
import { configureStore } from "@reduxjs/toolkit";
import tabReducer from "./common";

const rootReducer = {
  authData: authSlice,
  accountsData: accountsSlice,
  staffsData: staffsSlice,
  addressData: addressSlice,
  technicianData: technicianSlice,
  productsData: productsSlice,
  categoriesData: categoriesSlice,
  companiesData: companiesSlice,
  serviceData: serviceSlice,
  tab: tabReducer,
  salesData: salesSlice,
  settingData: settingSlice,
  dashboardData: dashboardSlice,
  notificationData: notificationSlice,
  salesReportData: salesReportSlice,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
